<template>
  <c-base-dialog v-model="isShow" :option="option" @close="$emit('close')">
    <template slot="body">
      <div :class="['dialog', 'dialog--default', !isMobile ? 'dialog--pc' : '']">
        <div class="dialog-content">
          <div>
            <table class="table">
              <tr>
                <th class="table-title">奖励时间</th>
                <th class="table-title">奖励名称</th>
              </tr>
              <tr v-for="(item, index) of list" :key="index">
                <td class="reward-list-item">{{ item.gift_time }}</td>
                <td class="reward-list-item" :style="{ paddingLeft: !isMobile ? '10px' : '0.1rem' }">
                  {{ item.show_gift_name }}
                  <a
                    v-if="item.package_real_flag === '1'"
                    class="item-link"
                    @click="$emit('fill-address')"
                  >填写收货地址</a>
                  <a
                    v-if="item.gift_name.length > 10"
                    class="item-link"
                    @click="showDetail(item.gift_name)"
                  >详情</a>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="reward-page" v-if="Math.ceil(page.total / pageSize) > 1">
          <a @click="page.current > 1 && page.current--">上一页</a>
          {{ page.current }}/{{ Math.ceil(page.total / pageSize) }}
          <a
            @click="page.current < page.total / pageSize && page.current++"
          >下一页</a>
        </div>
      </div>
    </template>
  </c-base-dialog>
</template>

<script>
import { ClaimRecord } from '../apis';
import CDialog from '../base-dialog';

export default {
  name: 'package-claim-record',
  components: {
    [CDialog.name]: CDialog,
  },
  props: {
    gameCode: String,
    params: Object,
    backgroundImage: String,
    hidePackageIds: Array,
    fontColor: {
      type: String,
      default: '#000',
    },
    option: Object,
    pageSize: Number,
  },
  data() {
    return {
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
      list: [],
      page: {
        current: 1,
        total: 0,
      },
      isShow: true,
    };
  },
  watch: {
    'page.current'() {
      this.freshList();
    },
  },
  methods: {
    async freshList() {
      if (this.$isInEditor) {
        this.list = new Array(this.pageSize).fill({
          gift_time: '2021-10-21 12:00:00',
          gift_name: '元宝x3',
          show_gift_name: '元宝x3',
          package_real_flag: '1',
        });
        this.page.total = 11;
        return;
      }
      ({ records: this.list, total: this.page.total } = await ClaimRecord.getClaimRecords({
        game_code: this.gameCode,
        ...this.params,
        page_size: this.pageSize,
        page_index: this.page.current,
      }));

      if (this.hidePackageIds) {
        this.list = this.list.filter(i => !~this.hidePackageIds.indexOf(i.gift_id));
      }
      this.list = this.list.map((i) => {
        const item = i;
        // 处理gift_id
        const giftIds = item.gift_id.split(',');
        const giftNames = item.gift_name.split(',');
        const newGiftNames = [];
        for (let i = 0; i < giftIds.length; i++) {
          const giftItems = giftIds[i].split(':');
          if (giftItems.length === 2 && giftItems[1] > '1') {
            newGiftNames.push(`${giftNames[i]} ${giftItems[1]}个`);
          } else {
            newGiftNames.push(giftNames[i]);
          }
        }
        item.show_gift_name = newGiftNames.join(',');
        item.gift_name = newGiftNames.join(',');
        if (item.show_gift_name.length > 10) item.show_gift_name = item.show_gift_name.substr(0, 10);

        return item;
      });
      console.log('packageList=', this.list);
    },
    showDetail(giftName) {
      this.alert(giftName);
    },
  },
  async mounted() {
    this.freshList();
    console.log('this.pageSize=', this.pageSize, this.list, this.isMobile);
  },
};
</script>

<style scoped>
.modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 100;
}
.dialog {
  font-size: 0.2rem;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 7.2rem;
  position: absolute;
}

.dialog-content {
  text-align: center;
  margin: 0 auto;
}

.dialog--default .table {
  border-collapse: collapse;
  width: 5.5rem;
  height: 2.3rem;
  margin: 0 auto;
  position: relative;
}

.dialog--default .reward-list-item {
  font-size: 0.24rem;
  white-space: nowrap;
}
.dialog--default .table-title {
  font-size: 0.28rem;
  padding-top: 0.1rem;
  line-height: 0.3rem;
  padding-bottom: 0.3rem;
}

.dialog--default .item-link {
  margin-left: 0.1rem;
  text-decoration: underline;
}
.dialog--default .reward-page {
  margin-top: 0.28rem;
}

/* pc */

.dialog--pc {
  font-size: 20px;
  width: 720px;
}

.dialog--pc .table {
  width: 550px;
  height: 230px;
}

.dialog--pc .reward-list-item {
  font-size: 24px;
}

.dialog--pc .table-title {
  font-size: 28px;
  padding-top: 10px;
  line-height: 30px;
  padding-bottom: 30px;
}

.dialog--pc .item-link {
  margin-left: 10px;
}

.dialog--pc .reward-page {
  margin-top: 28px;
}

</style>
